<div class="action-arrow__content">
	<a (click)="reOpen()"
		[attr.disabled]="actionsDisabled"
		[ngClass]="{
			'action-icon': true,
			'action-icon-inactive': !canReopen,
			'action-icon-active': canReopen,
			'disabled': actionsDisabled
		}">
		<i class="fas fa-undo"></i>
	</a>

	<a (click)="toggleReSubmitBox()"
		[attr.disabled]="actionsDisabled"
		[ngClass]="{
			'action-icon': true,
			'action-icon-inactive': !canResubmit,
			'action-icon-active': canResubmit,
			'disabled': actionsDisabled
		}">
		<i class="fas fa-file-upload"></i>
	</a>

	<span *ngIf="cellValue.data.locked"
		class="action-icon locked-by">
		<i class="fa fa-lock"
			[title]="getLockTitle()">
		</i>
		<span class="locked-by-information" [title]="getLockTitle()">
			<span class="locked-by">
				{{getNameInitials()}}
			</span>
		</span>
	</span>

	<a (click)="openOrder()"
		class="action-icon action-icon-active"
		[attr.disabled]="actionsDisabled"
		[ngClass]="{
			'disabled': actionsDisabled
		}">
		<i class="fas fa-arrow-right" *ngIf="!loadingOrder"></i>
		<div class="loading-wrapper" *ngIf="loadingOrder">
			<i class="fas fa-spinner"></i>
		</div>
	</a>

</div>
